// Charte graphique d'une exposition (Lot 2).
// Charge / enregistre exhibit_style, et expose des variables CSS réutilisables
// pour appliquer la charte par défaut sur l'accueil, les templates et les pages point.
import { ref } from 'vue';
import axios from 'axios';

const BASE = process.env.VUE_APP_BASEURL;

export const STYLE_DEFAULTS = {
  title_font: 'Arial',
  title_size: 48,
  title_color: '#1d1d1f',
  title_weight: '700',
  text_font: 'Arial',
  text_size: 16,
  text_color: '#333333',
  bg_color: '#ffffff',
  palette: [],
};

export function useExhibitStyle(exhibitId) {
  const style = ref({ ...STYLE_DEFAULTS });
  const loaded = ref(false);
  const hasStyle = ref(false); // true seulement si une charte est enregistrée pour cette expo

  const load = async () => {
    try {
      const { data } = await axios.get(`${BASE}/exhibit_style/${exhibitId}`);
      if (Array.isArray(data) && data.length) {
        style.value = { ...STYLE_DEFAULTS, ...data[0], palette: data[0].palette || [] };
        hasStyle.value = true;
      }
    } catch (e) {
      console.error('useExhibitStyle.load', e);
    } finally {
      loaded.value = true;
    }
  };

  const save = async () => {
    const payload = { exhibitId, ...style.value };
    const { data } = await axios.put(`${BASE}/exhibit_style`, payload);
    hasStyle.value = true;
    return data;
  };

  // Variables CSS à poser sur un conteneur racine (accueil/templates/intermediate).
  // Renvoie {} si aucune charte → le rendu garde ses valeurs par défaut (rétro-compatible).
  const cssVars = () => {
    if (!hasStyle.value) return {};
    return {
      '--expo-title-font': style.value.title_font,
      '--expo-title-size': `${style.value.title_size}px`,
      '--expo-title-color': style.value.title_color,
      '--expo-title-weight': style.value.title_weight,
      '--expo-text-font': style.value.text_font,
      '--expo-text-size': `${style.value.text_size}px`,
      '--expo-text-color': style.value.text_color,
      '--expo-bg': style.value.bg_color,
    };
  };

  return { style, loaded, hasStyle, load, save, cssVars };
}
